/** Типы файлов, принимаемые как пользовательский скриншот (зеркало валидации бэка) */
export const SCREENSHOT_ACCEPT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp'
];

/** Максимальный размер скриншота, МБ (симметрично валидации бэка) */
export const MAX_SCREENSHOT_SIZE_MB = 10;

/** Максимальный размер скриншота, байт */
export const MAX_SCREENSHOT_SIZE_BYTES = MAX_SCREENSHOT_SIZE_MB * 1024 * 1024;

/**
 * Картинка-файл пользователя → canvas для аннотатора.
 * Возвращает null, если файл не картинка или декодирование не удалось.
 * @param file - выбранный пользователем файл
 */
export const fileToCanvas = async (
  file: File
): Promise<HTMLCanvasElement | null> => {
  if (!SCREENSHOT_ACCEPT_TYPES.includes(file.type)) return null;

  try {
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement('canvas');

    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    canvas.getContext('2d')?.drawImage(bitmap, 0, 0);
    bitmap.close();

    return canvas;
  } catch {
    return null;
  }
};
